import { createFileRoute } from '@tanstack/react-router';
import { Users } from 'lucide-react';

export const Route = createFileRoute('/_dashboard/dashboard/contacts/')({
  component: ContactsIndexPlaceholder,
});

function ContactsIndexPlaceholder() {
  return (
    <div className="hidden h-full items-center justify-center p-6 text-sm text-muted-foreground md:flex">
      <Users className="mr-2 h-4 w-4" />
      Select a contact from the list.
    </div>
  );
}
